import React from 'react';
import classnames from 'classnames';
import { IconCloseMedium, IconLogoSquareGoparrot, IconBurger, Button } from '@goparrot-dashboard/shared-ui';
import { NavBarSidebar, Logo } from '.';

interface SquareHeadingButtonProps {
  isSidebarVisibleOnMobile: boolean;
  onClick: (visible: boolean) => void;
}

export const GoParrotHeading: React.FC<SquareHeadingButtonProps> = ({ isSidebarVisibleOnMobile, onClick }) => {
  return (
    <>
      <NavBarSidebar>
        <Logo />
      </NavBarSidebar>
      <Button
        kind="icon"
        color="clean"
        data-testid="mobile-logo"
        noFocusOutline={true}
        className="tw-block xl:tw-hidden tw-relative tw-z-1 tw-bg-white tw-ring-opacity-0 focus:tw-ring-opacity-0"
        onClick={() => onClick(!isSidebarVisibleOnMobile)}
      >
        {isSidebarVisibleOnMobile ? <IconCloseMedium /> : <IconBurger />}
      </Button>
      {!isSidebarVisibleOnMobile && (
        <Button
          kind="icon"
          color="clean"
          data-testid="mobile-logo"
          noFocusOutline={true}
          className={classnames([
            'tw-hidden tw-mb-1 tw-pl-2 sm:tw-block xl:tw-hidden tw-relative tw-z-1 tw-bg-white tw-ring-opacity-0 focus:tw-ring-opacity-0',
          ])}
          onClick={() => onClick(!isSidebarVisibleOnMobile)}
        >
          <IconLogoSquareGoparrot />
        </Button>
      )}
    </>
  );
};
